/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import SCB from '../../assets/images/SCB.png';
import KTC from '../../assets/images/ktc_logo.png';
import Installment from '../../assets/images/Installment.png';
import api from '../../utils/functions/api';

const InstallmentPopup = ({
  open,
  onClose,
  language,
  bank,
  tokens,
  etaxData,
  payType,
  totalAmount,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const urlOPS = useRef('');
  const formOPS = useRef('');

  const [selectedOption, setSelectedOption] = useState(null);
  const [payTypes, setPayTypes] = useState(null);
  const [selectedTerm, setSelectedTerm] = useState('');
  const terms = [3, 6, 10]; // จำนวนงวดสำหรับ KTC
  const installmentBank = bank?.find((item) => item.payType.startsWith('IN'));
  const bankDetails = installmentBank?.banks || [];

  // console.log('bankDetails', bankDetails);
  // console.log('selectedOption', selectedOption);

  useEffect(() => {
    if (bankDetails.length === 1) {
      const onlyBank = bankDetails[0];
      setSelectedOption(onlyBank.bankName);
      setPayTypes(onlyBank.payType);
    }
  }, [bankDetails]);

  const monthlyPayment = selectedTerm
    ? (
        Number(totalAmount.replace(/,/g, '')) / Number(selectedTerm)
      ).toLocaleString('th-TH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : null;
  const handleSelectOption = (optionLabel) => {
    const selectedBank = bankDetails.find((b) => b.bankName === optionLabel);
    console.log('selectedBank', selectedBank);
    if (selectedBank) {
      setSelectedOption(optionLabel);
      setPayTypes(selectedBank.payType);
      setSelectedTerm(''); // reset term ทุกครั้งที่เปลี่ยนธนาคาร
    }
  };

  const handlePaymentClick = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment`,
        {
          source: `${payTypes} ${selectedOption} ${
            etaxData?.branchCode ?? ''
          } ${etaxData?.tax ?? ''} ${etaxData?.postalCode ?? ''}`,
          eTaxData: {
            BUYER_NAME: etaxData?.name,
            BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
            BUYER_TAX_ID: etaxData?.taxId,
            BUYER_BRANCH_ID: etaxData?.branchCode,
            BUYER_POST_CODE: etaxData?.postalCode,
            BUYER_ADDRESS_LINE1: etaxData?.address,
            BUYER_ADDRESS_LINE2: etaxData?.address2,
          },
          etaxname: etaxData?.etaxname ?? '',
          etaxaddress1: etaxData?.etaxaddress1 ?? '',
          etaxaddress2: etaxData?.etaxaddress2 ?? '',
          email: etaxData?.email ?? '',
          term: payTypes?.startsWith('IN') ? selectedTerm : null,
          card_id: etaxData?.select_card?.card_id ?? '',
        },
        { headers: { Authorization: tokens } },
      );

      setIsLoading(false);
      if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending') {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (payTypes === 'IN-KTC') {
        urlOPS.current = data.tagUrl;
        formOPS.current = data.tagInput;
        setIsLoading(false);
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      } else {
        window.location.replace(data.paymentURL);
        urlOPS.current = data.paymentToken;
        formOPS.current = data.paymentURL;
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  const paymentOptions = [
    {
      label: 'SCB',
      icon: (
        <img src={SCB} alt="SCB" style={{ width: 'auto', margin: '2px 0' }} />
      ),
    },
    {
      label: 'KTC',
      icon: (
        <img src={KTC} alt="KTC" style={{ width: 'auto', margin: '2px 0' }} />
      ),
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '900px',
        },
      }}
    >
      <Loading isLoading={isLoading} />
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
            marginLeft: '20px',
          }}
        >
          {language === 'TH'
            ? 'เลือกธนาคารเพื่อชำระเงิน'
            : 'Select a bank for payment'}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            margin: '20px',
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* แสดงเฉพาะ Installment ถ้า bankDetails น้อยกว่า 2 */}
            {bankDetails.length < 2 && (
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <img
                  src={Installment}
                  alt="Installment"
                  style={{ width: '450px', height: 'auto' }}
                />
              </Grid>
            )}

            {/* แสดง payment options เฉพาะตอน bankDetails >= 2 */}
            {bankDetails.length >= 2 &&
              paymentOptions
                .filter(
                  (option) =>
                    Array.isArray(bankDetails) &&
                    bankDetails.some((b) => b.bankName === option.label),
                )
                .map((option, index) => (
                  <Grid item xs={6} md={4} key={index}>
                    <Paper
                      elevation={3}
                      sx={{
                        padding: { xs: '15px', md: '25px' },
                        textAlign: 'center',
                        borderRadius: '15px',
                        cursor: 'pointer',
                        border:
                          selectedOption === option.label
                            ? '2px solid #0288d1'
                            : 'none',
                        '&:hover': {
                          transform: 'scale(1.05)',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                        },
                      }}
                      onClick={() => handleSelectOption(option.label)}
                    >
                      {option.icon}
                    </Paper>
                  </Grid>
                ))}
          </Grid>
        </Box>

        {/* เฉพาะกรณีเลือก KTC */}
        {selectedOption === 'KTC' && (
          <Box
            sx={{
              marginTop: '10px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="term-select-label">
                {language === 'TH' ? 'จำนวนงวด' : 'Installment Terms'}
              </InputLabel>
              <Select
                labelId="term-select-label"
                id="term-select"
                value={selectedTerm}
                label={language === 'TH' ? 'จำนวนงวด' : 'Installment Terms'}
                onChange={(e) => setSelectedTerm(e.target.value)}
              >
                {terms.map((term) => (
                  <MenuItem key={term} value={term}>
                    {term} {language === 'TH' ? 'งวด' : 'months'}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {selectedTerm && (
              <Box textAlign="center" mt={3}>
                <Typography variant="subtitle2" color="textSecondary">
                  {language === 'TH'
                    ? 'ยอดผ่อนชำระต่อเดือน'
                    : 'Monthly Installment'}
                </Typography>
                <Typography variant="h5" color="primary" fontWeight="bold">
                  {monthlyPayment} ฿
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '40px',
          }}
        >
          <Button
            variant="outlined"
            color="error"
            sx={{ minWidth: 100 }}
            onClick={onClose}
          >
            {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
          </Button>

          <Button
            variant="outlined"
            color="success"
            sx={{ minWidth: 100 }}
            onClick={handlePaymentClick}
            disabled={
              bankDetails.length >= 2 ||
              !selectedOption ||
              (selectedOption === 'KTC' && !selectedTerm)
            }
          >
            {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default InstallmentPopup;
